import { StrictMode } from "react";
// The stylesheet is imported rather than linked from index.html: the bundler
// then owns it, so it ships hashed (a changed stylesheet can no longer be
// served from a stale cache) and every tool that reads this project — the
// design compiler among them — can find the design tokens where they are
// expected to live.
import "./styles.css";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { ActiveBookProvider } from "./features/books/activeBook";
import { ApiError } from "./shared/api/client";
import { App } from "./app/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: true,
      retry: (attempt, error) => error instanceof ApiError && error.status >= 500 && attempt < 2,
    },
    mutations: { retry: false },
  },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ActiveBookProvider>
          <App />
        </ActiveBookProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
